import React from 'react'
import mobile from '../../assets/BugBountyImages/mobile.png'
import system from '../../assets/BugBountyImages/system.png'

const HackingCourses = () => {
  return (
      <div>
          <div class=" container rounded  mt-0">

<div class="d-flex flex-wrap justify-content-between">
    <div class="col-lg-6 px-md-2 animate-fade">
        <img class="w-100 mb-3 border rounded" src={mobile}></img>
    </div>
    <div class="col-lg-6 px-md-2 animate-fade">
        <img class="w-100 mb-3 border rounded" src={system}></img>
    </div>


    <div class="d-none">
        <div class="col-lg-4 px-md-1">
            <img class="w-100 border rounded" src="images/mob.png"></img>
        </div>


        <div class="col-lg-4 px-md-1">
            <img class="w-100 border rounded" src="images/mob.png"></img>
        </div>


        <div class="col-lg-4 px-md-1">
            <img class="w-100 border rounded" src="images/mob.png"></img>
        </div>
    </div>
</div>
</div>
      
    </div>
  )
}

export default HackingCourses
